import ChevronDown from '@mdi/svg/svg/chevron-down.svg?react';
import ChevronUp from '@mdi/svg/svg/chevron-up.svg?react';
import { Button, Flex, MDIIcon } from '@solinkcorp/solink-components';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { logout } from './auth0';
import { LOGOUT_REASON } from './authConstants';
import { useLogoutHandlers } from './internal/AuthenticationContext';
import styles from './SSOError.module.sass';

const SSOError: React.FC<unknown> = () => {
  const [searchParams] = useSearchParams();
  const errorMessage = searchParams.get('message');
  const logoutHandlers = useLogoutHandlers();
  const [showDetails, setShowDetails] = React.useState(false);

  const handleLogin = () => {
    logout(undefined, logoutHandlers, LOGOUT_REASON.AUTHENTICATION_ERROR);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  return (
    <div>
      <Flex
        justifyContent="center"
        alignItems="center"
        height="100vh"
        className={styles.accessRestrictedWrapper}
        id="sso-error-container"
      >
        <Flex
          alignItems="center"
          flexDirection="column"
          height="600px"
          width="550px"
          className={styles.accessRestrictedCard}
        >
          <img title="Solink logo" src="images/large-solink.png" width="200px" />
          <Flex height="400px">
            <Flex
              alignItems="center"
              alignSelf="center"
              flexDirection="column"
              height="auto"
              width="100%"
              position="absolute"
              style={{ top: 0 }}
              className={styles.accessRestrictedError}
            >
              <h2 style={{ color: '#fff' }}>LOG IN FAILED</h2>
              <p style={{ color: '#fff', textAlign: 'center' }}>
                Please contact your system administrator for assistance.
              </p>
              <Button className={styles['details-button']} onClick={toggleDetails}>
                <div>
                  <p style={{ marginBottom: 0, letterSpacing: '1px' }}>
                    {showDetails ? 'HIDE DETAILS' : 'SHOW DETAILS'}
                  </p>
                  <MDIIcon icon={showDetails ? ChevronUp : ChevronDown} size={21} />
                </div>
              </Button>
              <Flex
                style={{
                  transition: 'all 300ms ease-in-out',
                  maxHeight: showDetails ? '500px' : '0',
                  overflow: 'hidden',
                  opacity: showDetails ? 1 : 0,
                  width: '100%',
                  justifyContent: 'center',
                }}
              >
                <p style={{ color: '#fff', textAlign: 'center' }}>
                  {`"${
                    errorMessage
                      ? errorMessage.replace('SSO user provisioning error: ', '')
                      : 'Unknown Error'
                  }"`}
                </p>
              </Flex>
            </Flex>
          </Flex>

          <Button onClick={handleLogin} className={styles['login-button']}>
            <p style={{ fontSize: '16px', letterSpacing: '1px' }}>BACK TO LOG IN</p>
          </Button>
        </Flex>
      </Flex>
    </div>
  );
};

export default SSOError;
